// Checked 2026-01-23 against UK tax year 2025-26 rules
export function income_tax(annual_gross_income: number): number {
  const LIMIT_0 = 12_570;
  const RATE_1 = 0.2;
  const LIMIT_1 = 50_270;
  const RATE_2 = 0.4;
  const LIMIT_2 = 100_000;
  const RATE_3 = 0.60;
  const LIMIT_3 = 125_140;
  const RATE_4 = 0.45;

  if (annual_gross_income <= LIMIT_0) {
    return 0;
  }

  if (annual_gross_income <= LIMIT_1) {
    return RATE_1 * (annual_gross_income - LIMIT_0);
  }

  if (annual_gross_income <= LIMIT_2) {
    return (
      (RATE_1 * (LIMIT_1 - LIMIT_0))
      + (RATE_2 * (annual_gross_income - LIMIT_1))
    );
  }

  if (annual_gross_income <= LIMIT_3) {
    return (
      (RATE_1 * (LIMIT_1 - LIMIT_0))
      + (RATE_2 * (LIMIT_2 - LIMIT_1))
      + (RATE_3 * (annual_gross_income - LIMIT_2))
    );
  }

  return (
    (RATE_1 * (LIMIT_1 - LIMIT_0))
    + (RATE_2 * (LIMIT_2 - LIMIT_1))
    + (RATE_3 * (LIMIT_3 - LIMIT_2))
    + (RATE_4 * (annual_gross_income - LIMIT_3))
  );
}

// Checked 2026-01-23 against UK tax year 2025-26 rules
export function national_insurance_c1(annual_gross_income: number): number {
  const LIMIT_0 = 1048 * 12;
  const RATE_1 = 0.08;
  const LIMIT_1 = 4189 * 12;
  const RATE_2 = 0.02;

  if (annual_gross_income <= LIMIT_0) {
    return 0;
  }

  if (annual_gross_income <= LIMIT_1) {
    return RATE_1 * (annual_gross_income - LIMIT_0);
  }

  return (
    (RATE_1 * (LIMIT_1 - LIMIT_0))
    + (RATE_2 * (annual_gross_income - LIMIT_1))
  );
}
